module.exports = __webpack_public_path__ + "static/media/swapInline.c096bc25.svg";